import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Login from './pages/Login';
import AdminLayout from './layout/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/login" component={Login} />
        <ProtectedRoute path="/app" component={AdminLayout} />
        <Redirect from="/" to="/app" />
      </Switch>
    </Router>
  );
}

export default App;
